import { BiPhone } from "react-icons/bi";
import { mainContact, toIntlPhone } from "../../data/artemulkContent";

function Call1() {
  const tel = toIntlPhone(mainContact.phone);

  return (
    <div className="call-btn-container">
      <a
        href={`tel:${tel}`}
        className="call-fab"
        aria-label={`Şimdi ara: ${mainContact.phone}`}
      >
        <span className="call-fab-icon">
          <BiPhone />
        </span>
        <span className="call-fab-text">Şimdi Ara</span>
      </a>
    </div>
  );
}

export default Call1;
